import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { BuyerGuides } from "@/components/BuyerGuides";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { IsoCertifications } from "@/components/IsoCertifications";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "IraqCert — ISO Certification Preparation & Vendor Registration in Iraq" },
      {
        name: "description",
        content:
          "ISO certification preparation and oil & gas vendor registration in Iraq. Issuing body and scope confirmed per engagement; ISO 29001 assessed separately.",
      },
      {
        property: "og:title",
        content: "IraqCert — ISO Certification Preparation & Vendor Registration in Iraq",
      },
      {
        property: "og:description",
        content:
          "ISO certification preparation and oil & gas vendor registration in Iraq. Issuing body and scope confirmed per engagement; ISO 29001 assessed separately.",
      },
      { property: "og:url", content: absolute("/") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/") }, ...hreflangLinks("/")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          faqPage(
            "/",
            content.faq.home.map((f) => ({ q: f.q.en, a: f.a.en })),
          ),
        ),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="bg-background">
        <Hero />
        <IsoCertifications />
        <WhyChooseUs />
        <BuyerGuides />
        <FaqSection items={content.faq.home} />
      </main>
      <Footer />
    </div>
  );
}
